import clsx from "clsx";
import { StaticImageData } from "next/image";

import { Image } from "@/components/displays";

import styles from "./ProductMainImage.module.scss";

interface ProductMainImageProps {
  imageSrc: StaticImageData | string;
}

export function ProductMainImage({ imageSrc }: ProductMainImageProps): React.ReactNode {
  return (
    <div className={styles.container}>
      <div className={clsx(styles.productSinglePhoto, "pt-2")}>
        <Image
          className={styles.featureRowImage}
          width={460}
          height={460}
          src={imageSrc}
          alt="商品画像"
          priority
          sizes="(max-width: 640px) 100vw, 460px"
        />
      </div>
    </div>
  );
}
